import { NAME } from './helpers';

const CapitalizedNameMentionsRegex = new RegExp(
	'(^|[^#])((?:' + NAME + '{' + 1 + ',})$)'
);

export default CapitalizedNameMentionsRegex;
